import styled from 'styled-components';
import { media } from '@peloton/styles/breakpoints';
import { spaces } from '@engage/styles/spaces';
import { Loading } from '@members/library/Classes/Loading';

export const LoadingMore = styled(Loading)`
  margin: ${spaces.small}px auto ${spaces.xLarge}px;
  ${media.smallScreen`
    margin: ${spaces.small}px auto ${spaces.xLarge}px;
  `}
  ${media.tablet`
    margin: ${spaces.small}px auto ${spaces.xLarge}px;
  `}
`;
LoadingMore.displayName = 'LoadingMore';
